import { AppAction } from 'types/app';
import { SephoraState } from 'types/sephora';
import { RECEIVE_SEPHORA_ERROR, RECEIVE_SEPHORA_LOYALTY, REQUEST_SEPHORA_LOYALTY } from 'constants/reduxActions';

const initialState = {
  isLoading: false,
  loyaltyId: undefined,
  tier: undefined,
  email: undefined,
  error: undefined
};

const Sephora = (state: SephoraState = initialState, action: AppAction): SephoraState => {
  switch (action.type) {
    case REQUEST_SEPHORA_LOYALTY:
      return {
        isLoading: action.showLoader
      };
    case RECEIVE_SEPHORA_LOYALTY:
      const { isValidated, loyaltyId, tier, email } = action;
      return {
        ...state,
        isLoading: false,
        isValidated,
        loyaltyId,
        tier,
        email
      };
    case RECEIVE_SEPHORA_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.message
      };
    default:
      return state;
  }
};

export default Sephora;
